module.exports = __webpack_public_path__ + "img/1ne.30a0a69e.svg";